import axios from "axios";


export async function getExercises(examId) {
  return axios
    .get(`${import.meta.env.VITE_API_BASE_URL}/api/exams/${examId}/exercises`)
    .then((response) => response.data)
    .catch((err) => console.error(err));
}

export async function getExam(examId) {
  return axios
    .get(`${import.meta.env.VITE_API_BASE_URL}/api/exams/${examId}`)
    .then((response) => response.data)
    .catch((err) => console.error(err));
}

/**
 * Inscribe a un estudiante en una practica.
 * @param {string} userId ID del estudiante.
 * @param {string} ExamsId ID del examen.
 * @return {Object} Respuesta.
 */
export async function enrollToExam(ExamsId, courseId) {
  const response = await axios.post(`${import.meta.env.VITE_API_BASE_URL}/api/exams/enroll`, {
    exam: Number(ExamsId),
    moduleId: Number(courseId),
  });
  return response.data;
}


export async function getStudentStatusExam(courseId) {
  return axios
    .get(`${import.meta.env.VITE_API_BASE_URL}/api/exams/getStudentStatus`, {
      params: { moduleId: courseId}
    })
    .then((response) => response.data)
    .catch((err) => console.error(err));
}


